import AppointmentPatientsList from "./AppointmentPatientsList";
export default AppointmentPatientsList;
